import * as React from 'react';
import { Link } from 'react-router';

import type { NavigationElement } from 'bundles/about/__generated__/baseContentfulTypes';

const TOP_OFFSET = 110;

export function scrollTo(section: $TSFixMe, smooth: $TSFixMe) {
  if (document && window) {
    const element = document.querySelector(`[data-section="${section}"]`);
    if (element) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'offsetTop' does not exist on type 'Eleme... Remove this comment to see the full error message
      const top = element.offsetTop - TOP_OFFSET;
      if (smooth) {
        window.scrollTo({ top, behavior: 'smooth' });
      } else {
        window.scroll(0, top);
      }
    }
  }
}

export const renderLink = (link: NavigationElement | null) => {
  return (
    link?.route && (
      <Link className="internal-about" key={link.route} href={link.route} data-e2e={link.route}>
        {link.label}
      </Link>
    )
  );
};

export default { scrollTo, renderLink };
